import { useQuery } from '@tanstack/react-query';
import { getAllGameTitles, type GameTitleEntry } from '../services/gamePerformanceService';

export const ALL_GAME_TITLES_QUERY_KEY = 'allGameTitles';

export function useAllGameTitles(enabled = true) {
	return useQuery<GameTitleEntry[], Error>({
		queryKey: [ALL_GAME_TITLES_QUERY_KEY],
		queryFn: getAllGameTitles,
		enabled,
		staleTime: 1000 * 60 * 5, // 5 minutes
		gcTime: 1000 * 60 * 10, // 10 minutes
		retry: 1,
	});
}